import { RANGE_PROBLEM } from "./ranges.js";

export const RANGE_PROBLEM_MESSAGE = Object.freeze({
  [RANGE_PROBLEM.MISSING_DATES]:
    "A date range needs a start date, an end date and a time zone.",
  [RANGE_PROBLEM.END_BEFORE_START]:
    "The end date must be on or after the start date.",
  [RANGE_PROBLEM.SPAN_TOO_LONG]: "A date range can last at most 30 days.",
  [RANGE_PROBLEM.STARTS_TOO_SOON]:
    "Date ranges must start at least 2 weeks out.",
});

export const PRINT_BOX_LOCK_MESSAGE = Object.freeze({
  admin:
    "This event has a print box, so its dates can't change. Delete the box first.",
  talent:
    "This event's dates can no longer be changed. Contact Streamily support to reschedule.",
});
